<template>
  <div class="comment">
    <div class="tech_box" v-for="(tech,index) in tech" :key="index">
      <div class="tech_info flex_center">
        <img :src="tech.thumb?tech.thumb:tech.avatar?tech.avatar:'/static/img/tech_head2.png'" alt />
        <span class="tech_name">{{tech.name}}</span>
      </div>

      <div class="total_score clear">
        <span class="total_score_lable fl">总体</span>
        <div class="total_score_xx fl">
          <van-rate
            v-model="tech_score[index].tech_total_score"
            allow-half
            void-icon="star"
            void-color="#D3D3D1"
            size="20"
          />
        </div>
        <div class="total_score_text fr" v-if="tech_score[index].tech_total_score >= 4">十分满意</div>
        <div
          class="total_score_text fr"
          v-if="tech_score[index].tech_total_score < 4 && tech_score[index].tech_total_score >= 2.5"
        >满意</div>
        <div class="total_score_text fr" v-if="tech_score[index].tech_total_score < 2.5">不满意</div>
      </div>

      <div class="total_score clear">
        <span class="total_score_lable fl">服务</span>
        <div class="total_score_xx fl">
          <van-rate
            v-model="tech_score[index].tech_service_score"
            allow-half
            void-icon="star"
            void-color="#D3D3D1"
            size="20"
          />
        </div>
        <div class="total_score_text fr" v-if="tech_score[index].tech_service_score >= 4">十分满意</div>
        <div
          class="total_score_text fr"
          v-if="tech_score[index].tech_service_score < 4 && tech_score[index].tech_service_score >= 2.5"
        >满意</div>
        <div class="total_score_text fr" v-if="tech_score[index].tech_service_score < 2.5">不满意</div>
      </div>

      <div class="total_score clear">
        <span class="total_score_lable fl">手法</span>
        <div class="total_score_xx fl">
          <van-rate
            v-model="tech_score[index].tech_operation_score"
            allow-half
            void-icon="star"
            void-color="#D3D3D1"
            size="20"
          />
        </div>
        <div class="total_score_text fr" v-if="tech_score[index].tech_operation_score >= 4">十分满意</div>
        <div
          class="total_score_text fr"
          v-if="tech_score[index].tech_operation_score < 4 && tech_score[index].tech_operation_score >= 2.5"
        >满意</div>
        <div class="total_score_text fr" v-if="tech_score[index].tech_operation_score < 2.5">不满意</div>
      </div>

      <div class="comment_textbox">
        <van-cell-group>
          <van-field
            v-model="tech_score[index].comment_text"
            type="textarea"
            placeholder="说说哪里好，其他顾客想知道..."
            rows="4"
            autosize
          />
        </van-cell-group>

        <!-- 需用数组存每个技师评论照片 -->
        <!-- <div class="comment_uploadimg">
          <div class="van-uploader__wrapper">
            <div class="van-uploader__upload">
              <i class="van-icon van-icon-plus van-uploader__upload-icon">

              </i>
            </div>
          </div>
        </div>-->
      </div>
    </div>

    <div class="tech_box store_box">
      <div class="tech_info store_info flex_center">
        <img :src="store.logo?store.logo:'/static/img/store_img2.png'" alt />
        <span class="tech_name">{{store.storename}}</span>
      </div>

      <div class="total_score clear">
        <span class="total_score_lable fl">总体</span>
        <div class="total_score_xx fl">
          <van-rate
            v-model="store_score.store_total_score"
            allow-half
            void-icon="star"
            void-color="#D3D3D1"
            size="20"
          />
        </div>
        <div class="total_score_text fr" v-if="store_score.store_total_score >= 4">十分满意</div>
        <div
          class="total_score_text fr"
          v-if="store_score.store_total_score < 4 && store_score.store_total_score >= 2.5"
        >满意</div>
        <div class="total_score_text fr" v-if="store_score.store_total_score < 2.5">不满意</div>
      </div>

      <div class="total_score clear">
        <span class="total_score_lable fl">环境</span>
        <div class="total_score_xx fl">
          <van-rate
            v-model="store_score.store_environment_score"
            allow-half
            void-icon="star"
            void-color="#D3D3D1"
            size="20"
          />
        </div>
        <div class="total_score_text fr" v-if="store_score.store_environment_score >= 4">十分满意</div>
        <div
          class="total_score_text fr"
          v-if="store_score.store_environment_score < 4 && store_score.store_environment_score >= 2.5"
        >满意</div>
        <div class="total_score_text fr" v-if="store_score.store_environment_score < 2.5">不满意</div>
      </div>

      <div class="total_score clear">
        <span class="total_score_lable fl">服务</span>
        <div class="total_score_xx fl">
          <van-rate
            v-model="store_score.store_service_score"
            allow-half
            void-icon="star"
            void-color="#D3D3D1"
            size="20"
          />
        </div>
        <div class="total_score_text fr" v-if="store_score.store_service_score >= 4">十分满意</div>
        <div
          class="total_score_text fr"
          v-if="store_score.store_service_score < 4 && store_score.store_service_score >= 2.5"
        >满意</div>
        <div class="total_score_text fr" v-if="store_score.store_service_score < 2.5">不满意</div>
      </div>

      <div class="comment_textbox">
        <van-cell-group>
          <van-field
            v-model="store_score.comment_text"
            type="textarea"
            placeholder="说说哪里好，其他顾客想知道..."
            rows="2"
            autosize
          />
        </van-cell-group>

        <div class="comment_uploadimg">
          <!-- <van-uploader  v-model="comment_imgbox" multiple :max-count="6" preview-size="55"/> -->
          <div class="van-uploader__wrapper">
            <div v-if="localIds.length > 0">
              <div class="van-uploader__upload" v-for="(item,index) in localIds" :key="index">
                <img :src="item" class="radius" alt @click="previewImage(item)" />
                <p
                  class="close fs_12"
                  @click="deleImg(index)"
                  style="position: absolute;top: 0;right: .2rem;font-size: 1rem !important;color:#45b9bc;"
                >×</p>
              </div>
            </div>

            <div class="van-uploader__upload" v-if="localIds.length < 4" @click="selectImg">
              <i class="van-icon van-icon-plus van-uploader__upload-icon">
                <!---->
              </i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="width:100%;margin:1.2rem 0;text-align:center;">
      <button class="send_btn" @click="release_comments">发布评价</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "comment",
  components: {},
  data() {
    return {
      orderid: "",
      tab_active: 0,
      tech_score: [
        // {tech_total_score:5,tech_service_score:5,tech_operation_score:5},
        // {tech_total_score:5,tech_service_score:5,tech_operation_score:5}
      ],

      store_score: {
        store_total_score: 5,
        store_environment_score: 5,
        store_service_score: 5,
        comment_text: ""
      },

      // 配置图片模块
      image: {
        // 文件最大体积，单位字节  max file size
        sizeLimit: 512 * 1024,
        // 上传参数,默认把图片转为base64而不上传
        upload: {
          url: null,
          headers: {},
          params: {},
          fieldName: {}
        },
        // 压缩参数,默认使用localResizeIMG进行压缩,设置为null禁止压缩
        compress: {
          width: 1600,
          height: 1600,
          quality: 80
        },
        // 响应数据处理,最终返回图片链接
        uploadHandler(responseText) {
          var json = JSON.parse(responseText);
          if (!json.ok) {
            alert(json.msg);
          } else {
            return json.data;
          }
        }
      },
      order: [],
      tech: [],
      store: [],
      refuse_arr: [],
      service: [],
      release: [],
      localIds: [], // 图片列表
      serverId: [] // 上传后返回的服务器id
    };
  },
  created() {
    this.orderid = this.$route.query.orderid;
    this.init();
  },
  methods: {
    init() {
      this.get_orderinfo();
    },
    get_orderinfo() {
      this.axios({
        url: this.api.order.order_detail, //获取订单信息
        data: { order_id: this.orderid }
      }).then(res => {
        if (res.error === 0) {
          this.order = res.data.order;
          this.tech = res.data.tech;
          this.store = res.data.store;
          this.refuse_arr = res.data.refuse_arr;
          this.service = res.data.service;
          this.tech_score = res.data.tech_score;
        }
      });
    },
    post() {
      this.axios({
        url: this.api.order.release_comments, //发布评价
        data: {
          release: this.release,
          localIds: this.localIds,
          thumbs: this.serverId
        }
      }).then(res => {
        if (res.error === 0) {
          this.$toast({
            message: res.msg,
            type: "success",
            onClose: () => {
              this.$router.push({ path: "/order", query: { status: 3 } });
            }
          });
        } else {
          this.$toast({
            message: res.error
          });
        }
      });
    },
    release_comments() {
            
      this.release.store_score = this.store_score;
      this.release.tech_score = this.tech_score;
      this.release.orderid = this.orderid;
      
      if (this.localIds.length == 0) {
        this.post();
      } else {
        this.upLoad_img();
      }
    },
    selectImg() {
      var that = this;
      this.axios({
        url: this.api.index.share_url,
        data: {
          url: window.location.href.split("#")[0]
        }
      }).then(function(res) {
        console.log(res.jssdkconfig);
        var shareMsg = res.jssdkconfig;
        wx.config({
          appId: shareMsg.appId,
          timestamp: shareMsg.timestamp,
          nonceStr: shareMsg.nonceStr,
          signature: shareMsg.signature,
          jsApiList: ["chooseImage", "uploadImage", "previewImage"]
        });
        wx.ready(function() {
          wx.chooseImage({
            // count: 1, // 默认9
            sizeType: ["original", "compressed"], // 可以指定是原图还是压缩图，默认二者都有
            sourceType: ["album", "camera"], // 可以指定来源是相册还是相机，默认二者都有
            success: function(res) {
              res.localIds.forEach(v => {
                // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                that.localIds.push(v);
              });
            }
          });
        });
      });
    },
    previewImage(url) {
      // 图片预览
      var that = this;
      wx.previewImage({
        current: url, // 当前显示图片的http链接
        urls: that.localIds // 需要预览的图片http链接列表
      });
    },
    deleImg(i) {
      this.localIds.splice(i, 1);
    },
    upLoad_img() {
      var that = this;
      var i = 0;
      var count = that.localIds.length;
        function upLoad() {
          // 多图上传
          wx.uploadImage({
            localId: that.localIds[i], // 需要上传的图片的本地ID，由chooseImage接口获得
            isShowProgressTips: 1, // 默认为1，显示进度提示
            success: function(res) {
              i++;
              that.$toast("已上传：" + i + "/" + count);
              that.serverId.push(res.serverId); // 返回图片的服务器端ID
              if (i < count) {
                upLoad(); // 递归上传图片
              } else {
                that.post();
              }
            }
          });
        }
        upLoad();
    }
  }
};
</script>
<style scoped>
.van-uploader__upload {
  width: 3rem;
  height: 3rem;
  float: left;
}
.van-uploader__upload img {
  width: 100%;
  height: 100%;
}
.icon-xingxing {
  font-size: 1rem;
}
.col_D3D3D1 {
  color: #d3d3d1;
}
.col_F9CE06 {
  color: #f9ce06;
}
.clear {
  overflow: hidden;
  clear: both;
}
.tech_box {
  padding: 0 0.75rem;
  padding-bottom: 0.75rem;
  background-color: white;
}
.tech_info {
  width: 100%;
  padding: 1rem 0;
}
.tech_info img {
  width: 2.2rem;
  height: 2.2rem;
  border-radius: 50%;
}
.store_info img {
  border-radius: 0 !important;
}
.tech_name {
  font-size: 0.7rem;
  color: #606262;
  margin-left: 0.5rem;
}
.total_score {
  font-size: 0.7em;
  color: #606262;
  line-height: 1.2rem;
  width: 75%;
  padding-bottom: 0.5rem;
}
.total_score_lable {
  padding-right: 0.65rem;
}
.total_score_xx span {
  margin-right: 0.5rem;
}
.total_score_text {
  font-size: 0.7rem;
  color: #969898;
}
.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border-width: 0;
}
.comment_textbox,
.van-cell {
  background-color: #eeeeee;
  color: #b1b1b1;
}
.store_box {
  margin: 0.4rem 0;
  padding-bottom: 0.4rem;
}
.comment_uploadimg {
  padding: 0.4rem 0.7rem;
}
.comment_uploadimg li {
  width: 2.2rem;
  height: 2.2rem;
  line-height: 2.2rem;
  text-align: center;
  float: left;
  margin-right: 2.7%;
  margin-bottom: 0.5rem;
}
.comment_uploadimg li img {
  width: 100%;
  height: 100%;
}
.send_btn {
  color: #ffffff;
  background-color: #45b9bc;
  border-radius: 4px;
  font-size: 1rem;
  padding: 0.5rem 0;
  width: 75%;
}
</style>



// WEBPACK FOOTER //
// src/views/order/comment.vue